/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Member_Details_DescriptionInputs */



/**
* | output |
* | --- |
* | "Per-member usage with expandable model details" |
*
* @param {Dashboard_Member_Details_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_member_details_description = /** @type {((inputs?: Dashboard_Member_Details_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Member_Details_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzung pro Mitglied mit aufklappbaren Modelldetails")
	return /** @type {LocalizedString} */ ("Per-member usage with expandable model details")
});